import gql from 'graphql-tag';

interface GetDynamicWidgetsMetaInput {
  widgetGroup: 'invoiceAudit' | 'billingQueue';
}

const GET_DYNAMIC_WIDGETS_META = gql`
  query($input: GetDynamicWidgetsMetaInput!) {
    getDynamicWidgetsMeta(input: $input)
  }
`;

export { GET_DYNAMIC_WIDGETS_META };

export type { GetDynamicWidgetsMetaInput };
